export default __webpack_public_path__ + "static/media/compare__item-img-1.a11cbb67.svg";